import React, { useState, useEffect, useRef } from "react";
import {
  Modal, Box, Typography, TextField, Select, MenuItem, Button,
  IconButton, Divider, InputLabel, FormControl, GlobalStyles
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  maxHeight: "90dvh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
};

const AddResponses = ({ apiResponses, setApiResponses, openResponses, setOpenResponses, handleResponseClose, selectedResponse }) => {
  const [responseType, setResponseType] = useState("");
  const [responseStatusCode, setResponseStatusCode] = useState("");
  const [responseDescription, setResponseDescription] = useState("");
  const [responseModeType, setResponseModeType] = useState("");
  const [responsePayload, setResponsePayload] = useState("");

  useEffect(() => {
    if (selectedResponse && openResponses) {
      setResponseType(selectedResponse.name || "");
      setResponseStatusCode(selectedResponse.statusCode || "");
      setResponseDescription(selectedResponse.description || "");
      setResponseModeType(selectedResponse.responseModeType || "");
      setResponsePayload(selectedResponse.payload || "");
    }
    else{
      setResponseType("");
      setResponseStatusCode("");
      setResponseDescription("");
      setResponseModeType("");
      setResponsePayload("");
    }
  }, [selectedResponse, openResponses]);

  const handleSave = () => {
    console.log({ responseType, responseStatusCode, responseDescription, responseModeType, responsePayload });
    const updatedResponse = {
      name: responseType,
      statusCode: responseStatusCode,
      description: responseDescription,
      responseModeType: responseModeType,
      payload: responsePayload,
    };
  
    if (selectedResponse) {
      const index = apiResponses.findIndex(
        (res) =>
          res.name === selectedResponse.name &&
          res.statusCode === selectedResponse.statusCode
      );
  
      if (index !== -1) {
        const updatedResponses = [...apiResponses];
        updatedResponses[index] = updatedResponse;
        setApiResponses(updatedResponses);
      }
    } else {
      setApiResponses((prev) => [...prev, updatedResponse]);
    }

    setResponseType("");
    setResponseStatusCode("");
    setResponseDescription("");
    setResponseModeType("");
    setResponsePayload("");
  
    handleResponseClose();
  };
  

  return (
    <Modal open={openResponses} onClose={handleResponseClose} disableEnforceFocus>
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="20px 30px">
          <Typography sx={{ fontSize: '18px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>Create Product</Typography>
          <Box>
            <IconButton onClick={handleResponseClose}><CloseIcon /></IconButton>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ p: "20px 30px", overflow: "auto", maxHeight: "calc(100vh - 245px)" }}>
          <Box>
            <TextField
              variant="outlined"
              name="Response_type"
              label="Response Type"
              placeholder={responseType ? "" : "For example: Success"}
              type="text"
              value={responseType}
              onChange={(e) => setResponseType(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: responseType ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: responseType ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: responseType ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>

          <Box mt={2}>
            <TextField
              variant="outlined"
              name="Response_StatusCode"
              label="Response Status Code"
              placeholder={responseStatusCode ? "" : "For example: 200"}
              type="text"
              value={responseStatusCode}
              onChange={(e) => setResponseStatusCode(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: responseStatusCode ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: responseStatusCode ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: responseStatusCode ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>

          <Box mt={2}>
            <TextField
              variant="outlined"
              name="description"
              label="Description"
              type="text"
              value={responseDescription}
              onChange={(e) => setResponseDescription(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: responseDescription ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: responseDescription ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: responseDescription ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>

          <Box mt={2}>
            <TextField
              variant="outlined"
              name="response_mode_type"
              label="Response Mode Type"
              type="text"
              value={responseModeType}
              onChange={(e) => setResponseModeType(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: responseModeType ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: responseModeType ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: responseModeType ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>

          <Box mt={2}>
            <TextField
              fullWidth
              multiline
              minRows={6}
              placeholder="{}"
              value={responsePayload}
              onChange={(e) => setResponsePayload(e.target.value)}
            />
          </Box>
        </Box>

        <Divider mt="10px" />

        <Box display="flex" justifyContent="end" alignItems="center" p="20px 30px" gap="15px">
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={handleResponseClose} >
                Cancel
            </Button>
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, "&:hover": {background: "#185CB7", color: "#ffffff", borderColor: "#185CB7"} }} onClick={handleSave} >
                Save
            </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddResponses;
